var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectExtinguisherCritical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 1.5,
    width: 52,
    height: 53,
    rx: 6.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 1.5,
    width: 52,
    height: 53,
    rx: 6.5,
    stroke: "#FF8027",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3126 25.0098H30.8165C32.596 25.0098 34.0381 26.452 34.0382 28.2315V43.0098H24.0909V28.2315C24.0909 26.452 25.5331 25.0098 27.3126 25.0098Z",
    fill: "white",
    stroke: "#FF8027",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2523 18.7098H29.7738C30.4151 18.7098 30.935 19.2297 30.935 19.8709V24.1092H27.0912V19.8709C27.0912 19.2297 27.6111 18.7098 28.2523 18.7098Z",
    fill: "white",
    stroke: "#FF8027",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3646 18.3094L37.0939 16.6194C37.4421 16.5167 37.6821 16.1983 37.685 15.8353L37.7013 13.82C37.7026 13.6595 37.5281 13.5592 37.3901 13.6411L31.0396 17.4082L31.3646 18.3094Z",
    stroke: "#FF8027",
    strokeWidth: 1.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0226 19.7949L35.8362 22.5762C36.1585 22.7625 36.5657 22.7096 36.8297 22.4473L38.3489 20.938C38.4607 20.8269 38.4115 20.6364 38.2598 20.5935L31.2706 18.6143L31.0226 19.7949Z",
    stroke: "#FF8027",
    strokeWidth: 1.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4653 18.3522C32.4653 19.149 31.8194 19.7949 31.0226 19.7949C30.2258 19.7949 29.5798 19.149 29.5798 18.3522C29.5798 17.5554 30.2258 16.9094 31.0226 16.9094C31.8194 16.9094 32.4653 17.5554 32.4653 18.3522Z",
    fill: "#FF8027",
    stroke: "#FF8027",
    strokeWidth: 0.206107
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1258 16.6653C32.1141 16.6654 32.9149 17.467 32.9149 18.4554C32.9148 19.4437 32.1141 20.2443 31.1258 20.2444C30.1374 20.2444 29.3358 19.4437 29.3358 18.4554C29.3358 17.4669 30.1374 16.6653 31.1258 16.6653ZM31.1258 18.1614C30.9633 18.1614 30.8318 18.2928 30.8318 18.4554C30.8319 18.6178 30.9633 18.7493 31.1258 18.7493C31.2882 18.7492 31.4197 18.6178 31.4197 18.4554C31.4197 18.2929 31.2882 18.1615 31.1258 18.1614Z",
    fill: "white",
    stroke: "#FF8027",
    strokeWidth: 0.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9895 18.5774H26.4352C26.289 18.5774 26.1455 18.6162 26.0193 18.6899L23.2835 20.2883C22.0086 21.0332 21.0943 22.2676 20.7535 23.7043L18.5396 33.0354L16.2805 36.7584L20.5545 37.6147L20.9209 33.5239L22.9232 24.7769C23.0928 24.036 23.4935 23.3682 24.0675 22.87V22.87L26.0054 21.591C26.1402 21.5021 26.2981 21.4547 26.4595 21.4547H27.4198",
    stroke: "#FF8027",
    strokeWidth: 1.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7573 30.4094H34.5779",
    stroke: "#FF8027",
    strokeWidth: 1.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6028 38.7567H34.4234",
    stroke: "#FF8027",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectExtinguisherCritical);
export default __webpack_public_path__ + "static/media/object-extinguisher-critical.b7745de72f7560f6cb05550faa2edfe0.svg";
export { ForwardRef as ReactComponent };